// extracted by css-extract-rspack-plugin
export default {"buttonWrapper":"button-wrapper--C81lZ3Ln85A_AX2r"};